import { render, staticRenderFns } from "./ShipmentSummaryPanel.vue?vue&type=template&id=133d3148&scoped=true&"
import script from "./ShipmentSummaryPanel.vue?vue&type=script&lang=js&"
export * from "./ShipmentSummaryPanel.vue?vue&type=script&lang=js&"
import style0 from "./ShipmentSummaryPanel.vue?vue&type=style&index=0&id=133d3148&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "133d3148",
  null
  
)

export default component.exports